import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-book-settings.component',
  templateUrl: './icon-book-settings.component.html',
  styleUrl: './icon-book-settings.component.scss',
  standalone: false,
})
export class IconBookSettingsComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
